// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__MGLiy","colCheckbox":"styles_colCheckbox__1D0NX"};